import React from 'react'
import { getLiveApi } from './api'
import {
    Dashboard,
    DashboardsResponse,
    DashboardWidgets,
    DashboardWidget
} from '../common/types/api/DashboardsResponse'

import GlobalNotification from 'live/services/global-notification'
import { Notification } from '../common/components/Notification/Notification'
import i18n from 'live/services/i18n'

export default async function getDashboards(): Promise<Dashboard[]> {
    try {
        const dashResponse = await getLiveApi<DashboardsResponse>(`dashboard`)

        return dashResponse.data
    } catch (error) {
        const errorMsg = i18n('Error trying to get Dashboards: ')
        GlobalNotification.error(<Notification title={errorMsg}>{error}</Notification>, 20)
        console.error(errorMsg, error)

        return []
    }
}

export async function getDashboard(id: number): Promise<DashboardWidgets> {
    try {
        const dashResponse = await getLiveApi<DashboardWidgets>(`dashboard/${id}`)

        return dashResponse
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error trying to get Report: ')}>
                <tr>
                    <strong>Dashboard id: </strong> {id}
                </tr>
                {error}
            </Notification>,
            20
        )

        console.error(error)

        return {
            widgets: []
        }
    }
}

export async function getWidget(id: number): Promise<DashboardWidget> {
    try {
        const dashResponse = await getLiveApi<DashboardWidget>(`dashboard-widget/${id}`)

        return dashResponse
    } catch (error) {
        GlobalNotification.error(
            <Notification title={i18n('Error trying to get widget: ')}>
                <tr>
                    <strong>Widget id: </strong> {id}
                </tr>
                {error}
            </Notification>,
            20
        )

        console.error(error)

        return null
    }
}
export function mockGetLookups(data: Dashboard[]): () => Promise<Dashboard[]> {
    return function (): Promise<Dashboard[]> {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve(data)
            }, 1000)
        })
    }
}
